<template>
    <img :src="imgurl" @error="handleError" :style="{ opacity: isLoaded ? 1 : 0.8 }">
</template>
<script>
export default {
    name: 'cm-img',
    data() {
        return {
            imgurl: this.defaultImg,
            isLoaded: false
        };
    },
    props: {
        src: {
            type: String,
            default: this.noImgData
        },
    },
    // watch: {
    //     src: {
    //         handler(src) {
    //             // this.imgurl = this.defaultImg;
    //             // if (!src) {
    //             //     this.imgurl = this.noImgData;
    //             // }
    //             // else {
    //             //     this.imgurl = src;
    //             // }
    //             // console.log('src', src);
    //             // this.imgurl = src;
    //         },
    //         immediate: true
    //     }
    // },
    mounted() {
        const img = new Image()
        img.onload = () => {
            this.imgurl = this.src;
            this.isLoaded = true // 即使失败也解除加载状态
        }
        // img.onerror = () => {
        //     this.imgurl = this.noImgData;
        //     this.isLoaded = true // 即使失败也解除加载状态
        // }
        img.src = this.defaultImg
    },
    methods: {
        handleLoad(e) {
            e.target.src = this.src
            this.isLoaded = true // 即使失败也解除加载状态
        },
        handleError(e) {
            e.target.src = this.noImgData
            this.isLoaded = true // 即使失败也解除加载状态
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/components/CmImg/index.vue